import React from 'react'
import PropTypes from 'prop-types'
import PerformanceItem from '../PerformanceItem'

function CpmModal() {
	return (
		<div className='performance_item_modal cpm_modal'>
			<h3>CPM</h3>
			<p>
				With Facebook global CPMs increasing overall, it&apos;s more important than ever for marketers to focus on cost efficiency.
			</p>
			<p>
				Whether you are focused on performance or awareness, ads that resonate with their target audience typically get the best CPMs.
			</p>
			<p>
				We&nbsp;ve seen CPMs fall as low as $2 with a proper strategy.
			</p>
		</div>
	)
}

const renderCpmBody = (value, global, us) => {
	if(value===null) {
		return <p>We could not calculate your CPM as you have not run ads in the past 30 days.</p>
	}
	let currencyStr = parseFloat(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
	let percentDiff = (Math.abs(us-value)/ us).toLocaleString('en', {style: 'percent'})
	let domesticLowHigh = value < us ? 'lower' : 'higher'
	let globalPercentDiff = (Math.abs(global-value)/global).toLocaleString('en', {style: 'percent'})
	let globalLowHigh = value > global ? ' higher' : ' lower'		
	return (
		<p>Your CPM is {currencyStr} which is {percentDiff} {domesticLowHigh} than the U.S. industry average and {globalPercentDiff} {globalLowHigh} than the global average.</p>
	)
}

function CpmPerformanceItem(props) {
	const { score, maxScore, value, benchmark: { global, us } } = props.apiScore
	
	// "cpm":{"score":10,"maxScore":10,"value":0.38,"benchmark":{"us":7,"global":7}}
	return (
		<PerformanceItem
			title="CPM"
			score={score}
			maxScore={maxScore}
			showPerformanceModal={() => { props.showPerformanceModal('cpm') }}>
			{renderCpmBody(value, global, us)}
		</PerformanceItem>
	)
}
CpmPerformanceItem.propTypes = {
	apiScore: PropTypes.object,
	showPerformanceModal: PropTypes.func
}

export {CpmModal, CpmPerformanceItem}


// WEBPACK FOOTER //
// ./src/containers/ReportLoader/components/performance_items/Cpm.js